// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { PropsValue } from 'react-select';
import { ISelectRequiredOption } from 'common/components';
import { Translate } from '@plesk/ui-library';
import { STORAGE_TYPES_TRANSLATION_MAP } from 'common/api/resources/StorageType';
import SelectInput from 'common/components/Select/SelectInput';
import { FixedFormField } from 'admin/common/components/Filters/Styles';
import { FILTERS } from 'admin/common/constants/tests';

interface IStorageTypeFilterProps {
    onChange: (option: PropsValue<ISelectRequiredOption>) => void;
    value?: ISelectRequiredOption;
    margin_left?: string;
}

export const StorageTypeFilter: React.FC<IStorageTypeFilterProps & React.ComponentProps<typeof FixedFormField>> = ({
    onChange,
    value,
    margin_left,
    ...props
}) => {
    const storageTypeOptions: ISelectRequiredOption[] = Object.entries(STORAGE_TYPES_TRANSLATION_MAP).map(
        ([key, label]) => ({
            value: key,
            label,
        })
    );

    return (
        <FixedFormField margin_left={margin_left} data-cy={FILTERS.STORAGE_TYPE} {...props}>
            <SelectInput
                inputId="storage-type-filter"
                placeholder={<Translate content="filters.storageType" />}
                options={storageTypeOptions}
                isClearable={true}
                onChange={onChange}
                value={value}
                menuPosition="absolute"
                menuPortalTarget={document.body}
            />
        </FixedFormField>
    );
};
